<template>
  <div class="dropdown__item flex h-8 items-center justify-start gap-1.5 px-3 text-sm leading-[30px]" tabindex="0">
    <Icon src="magnifying_glass" />
    <input
      ref="input"
      v-model="search"
      class="h-5 w-full focus-visible:border-0 focus-visible:outline-none"
      type="text"
      :placeholder="placeholder"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref } from "vue";

  const input = ref<HTMLInputElement | null>(null);
  const search = defineModel<string>({ default: "" });

  withDefaults(
    defineProps<{
      placeholder?: string;
    }>(),
    {
      placeholder: "",
    }
  );

  defineExpose({
    focus() {
      input.value?.focus();
    },
  });
</script>
